import { DataSource, exampleDataSourceWithSuggestions } from '../data-source';
import { OfflineUploadSourceType } from './OfflineEventSetUpload';
import { FacebookAPIUploadType } from './UserUpload';

export interface UploadDailyAttribution {
  day: string;
  newCustomers: number;
  repeatCustomers: number;
  estRevenue?: number; // only used for estimated clients
  revenue?: number; // revenue only clients
  expectedRevenue?: number; // will be projected revenue for collected purchase values
}

export interface AttributedBreakdown {
  attributed: {
    new: number;
    repeat: number;
    total: number;
  };
  extrapolated: {
    new: number;
    repeat: number;
    unmatched: number;
    total: number;
  };
  total: number;
}

export interface UploadAttributionSummary {
  dataType: DataSource;
  fbAPIUploadType: FacebookAPIUploadType;
  startDate: string; // ISO string
  endDate: string; // ISO string
  matchedEvents: number;
  //Total number of events Facebook accepted.
  fbValidEvents: number;
  //Total number of events uploaded to Facebook
  fbTotalUploaded: number;
  //Total number of events uploaded to Marketing Milk
  mmTotalUploaded: number;
  //Total number of benchmarked events (i.e. greater than 90 days old)
  benchmarkedEvents: number;
  uploadedRevenue: number;
  matchRate: number; // 0 - 1
  attributionRate: number; // 0 - 1
  attributedEvents: AttributedBreakdown;
  attributedRevenue?: AttributedBreakdown;
  unMatchedEvents?: number;
  unMatchedRevenue?: number;
  totalRevenueForYear?: number;
  attributedExpRevenue?: number;
  attributedEstEvents?: number;
  attributedEstRevenue?: number;
  uploadedTo: OfflineUploadSourceType[];
}

export interface UploadAttributionStats {
  summary: UploadAttributionSummary;
  rows: UploadDailyAttribution[];
}

export const testUploadAttributionStats: UploadAttributionStats = {
  summary: {
    dataType: exampleDataSourceWithSuggestions,
    fbAPIUploadType: 'OfflineConversionsAPI',
    startDate: '2019-01-01',
    endDate: '2019-01-03',
    matchedEvents: 80,
    fbValidEvents: 90,
    fbTotalUploaded: 100,
    mmTotalUploaded: 150,
    benchmarkedEvents: 0,
    uploadedRevenue: 10000,
    matchRate: 0.8,
    attributionRate: 0.2,
    attributedEvents: {
      attributed: {
        new: 14,
        repeat: 6,
        total: 14 + 6,
      },
      extrapolated: {
        new: 3,
        repeat: 1,
        unmatched: 1,
        total: 3 + 1,
      },
      total: 25,
    },
    attributedRevenue: {
      attributed: {
        new: 1750,
        repeat: 750,
        total: 1750 + 750,
      },
      extrapolated: {
        new: 600,
        repeat: 200,
        unmatched: 100,
        total: 600 + 200,
      },

      total: 3400,
    },
    totalRevenueForYear: 700 + 3400,
    attributedExpRevenue: 700,
    uploadedTo: [OfflineUploadSourceType.OfflineEventSet],
  },
  rows: [
    {
      day: '2019-01-01',
      newCustomers: 4,
      repeatCustomers: 3,
      revenue: 300,
      expectedRevenue: 200,
    },
    {
      day: '2019-01-02',
      newCustomers: 4,
      repeatCustomers: 5,
      revenue: 500,
      expectedRevenue: 400,
    },
    {
      day: '2019-01-03',
      newCustomers: 4,
      repeatCustomers: 4,
      revenue: 1000,
      expectedRevenue: 900,
    },
  ],
};
